import { AuthenticationContext } from "react-adal";

export const config = {
  clientId: "73c1c68a-cdfd-458d-b3ca-140b159931a1",
  cacheLocation: "localStorage",
  redirectUri: "https://admin.heedify.io/",
};

export const authContext = new AuthenticationContext(config);
